import React, { useState } from "react";
import * as Mui from "@mui/material";
import {
  Box,
  Typography,
  Divider,
  Card,
  CardContent,
  IconButton,
} from "@mui/material";
import { CustomButton } from "components/CustomComponents";
import { CustomTable } from "../Component/ShiftCategoryOptions";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import { customAPI } from "services/utils/CustomAPI";
import { boxStyleSx } from "../Component/ShiftCategoryOptions";
import { CustomButtonWithBorder } from "components/CustomComponents/CustomButton";
import { Close } from "@mui/icons-material";

export const Preview = ({
  handleBack,
  basicInfoData,
  earningData,
  deductionsData,
  onClose,
  closeEditScreen,
  reCallApi,
  isPreview,
  isEditScreen,
  setHandleLoader,
  setViewScreenData,
  isCreateScreen,
  clearAbsenceValues,
  sftPenaltyPolicy,
  onTaskResponse,
  editCategoryDetails,
  setIsViewPanelOpen,
}) => {
  const { setValue, watch, handleSubmit } = useForm();
  const { domain } = useSelector((state) => state.tokenReducer);

  const [openDialogConfimation, setOpenDialogConfimation] = useState(false);

  const [buttonLoader, setButtonLoader] = useState(false);
  const [formValues, setFormValues] = useState(null);

  const mainFields = [
    {
      label: "Payment Based On",
      value: basicInfoData?.payment_based_on,
      table: basicInfoData?.payment_based_on === "Partial Shift Credit",
      tableData: basicInfoData?.rows,
      data:
        basicInfoData?.payment_based_on === "Partial Shift Credit" ? (
          <Typography variant="body2" color="text.secondary">
            Each additional{" "}
            <strong>{basicInfoData?.additional_percentage}</strong> percentage
            is counted as <strong>{basicInfoData?.shift_count}</strong> shift
          </Typography>
        ) : (
          ""
        ),
    },
    {
      label: "Payment hours calculation based on",
      value: basicInfoData?.is_include_sft_grade_sfts,
    },

    {
      label: "Is OverTime Allowed",
      value: earningData?.is_overtime_allowed ? "Yes" : "No",
      subFields: earningData?.is_overtime_allowed
        ? [
            {
              label: "OT work preauthorization",
              value:
                earningData?.ot_work_preauthorization === "Automatic"
                  ? "Automatic"
                  : "Manual",
            },
            ...(earningData?.ot_work_preauthorization === "Automatic"
              ? [
                  {
                    label: "OT timing preference",
                    value:
                      earningData?.ot_timing_privilege === "Only Before"
                        ? "Before Shift"
                        : earningData?.ot_timing_privilege === "Only After"
                          ? "After shift"
                          : "Both",
                  },
                ]
              : []),

            {
              label: "Calculation based on",
              value: earningData?.calculation_based_on,
            },
            ...(earningData?.calculation_based_on === "Hours"
              ? [
                  {
                    label: "Payment based on",
                    value:
                      earningData?.is_ot_payment_based_on === "Amount"
                        ? "Fixed Amount"
                        : "Attendance",
                  },
                ]
              : []),
            {
              label: "Is OT pay added to payroll by default",
              value: earningData?.is_ot_pay_by_default ? "Yes" : "No",
            },
          ]
        : [],
      table:
        earningData?.calculation_based_on === "Shift" &&
        earningData?.is_overtime_allowed,
      tableData: earningData?.rows,
      data:
        earningData?.is_overtime_allowed &&
        earningData?.calculation_based_on === "Hours" ? (
          <Box>
            {earningData?.is_ot_payment_based_on === "Attendance" ? (
              <Box>
                <Typography variant="body2" color="text.secondary" mb={1}>
                  The threshold limit for overtime is{" "}
                  <strong>{earningData?.minimum_ot_consideration}</strong> mins
                  will be considered as{" "}
                  <strong>{earningData?.minutes_for_consideration}</strong> mins{" "}
                  <strong>{earningData?.attendance_deduct_type}</strong>
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  After that, every additional{" "}
                  <strong>{earningData?.additional_ot}</strong> mins will be
                  considered as{" "}
                  <strong>
                    {earningData?.additional_minutes_for_consideration}{" "}
                  </strong>
                  <strong>{earningData?.attendance_deduct_type}</strong>
                </Typography>
              </Box>
            ) : (
              <Box>
                <Box mb={1}>
                  <Typography variant="body2" color="text.secondary">
                    The threshold limit for overtime is{" "}
                    <strong>
                      {earningData?.ot_fixed_amount_thereshold_limit}
                    </strong>{" "}
                    mins with an amount payable of{" "}
                    <strong>{earningData?.ot_fixed_amount_payable}</strong>{" "}
                    <strong>{earningData?.fixed_amount_deduct_type}</strong>
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    For every additional{" "}
                    <strong>
                      {earningData?.ot_fixed_amount_additional_mins}
                    </strong>{" "}
                    mins an additional{" "}
                    <strong>
                      {earningData?.ot_fixed_amount_additional_payable}{" "}
                    </strong>
                    will be payable{" "}
                    <strong>{earningData?.fixed_amount_deduct_type}</strong>
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        ) : earningData?.is_overtime_allowed &&
          earningData?.calculation_based_on === "Shift" ? (
          <Box>
            <Typography variant="body2" color="text.secondary">
              Each additional{" "}
              <strong>{earningData?.deduct_additional_percentage}</strong>{" "}
              percentage is counted as{" "}
              <strong>{earningData?.deduct_shift_count}</strong> shift
            </Typography>
          </Box>
        ) : (
          ""
        ),
    },
  ];

  //weekoff fields

  const weekoffFields = [
    {
      label: "Weekoff",
    },
    {
      label: "Is Weekoff Paid",
      value: earningData?.is_weekoff_paid ? "Yes" : "No",
      indent: true,
    },
    {
      label: "Payment for weekoff day attendance",
      value: earningData?.is_payment_for_weekoff_day_attendance ? "Yes" : "No",
      indent: true,
    },
    ...(earningData?.is_payment_for_weekoff_day_attendance
      ? [
          {
            label:
              earningData?.is_weekoff_payment_based_on === "Attendance"
                ? "Payment for weekoff attendance based on:"
                : "Payment for weekoff fixed amount based on:",
            value:
              earningData?.is_weekoff_payment_based_on === "Attendance"
                ? `Payment factor: ${
                    earningData?.weekoff_attendance_payment_factor ?? "N/A"
                  }`
                : `Fixed Amount: ${
                    earningData?.weekoff_attendance_fixed_amount ?? "N/A"
                  }`,
            indent: true,
          },
        ]
      : []),
  ];

  //holidayfields
  const holidayFields = [
    {
      label: "Holiday",
    },
    {
      label: "Is holiday Paid",
      value: earningData?.is_holiday_paid ? "Yes" : "No",
      indent: true,
    },
    {
      label: "Payment for holiday attendance",
      value: earningData?.is_payment_for_holiday_day_attendance ? "Yes" : "No",
      indent: true,
    },
    ...(earningData?.is_payment_for_holiday_day_attendance
      ? [
          {
            label:
              earningData?.is_holiday_payment_based_on === "Attendance"
                ? "Payment for holiday attendance based on:"
                : "Payment for holiday fixed amount based on:",
            value:
              earningData?.is_holiday_payment_based_on === "Attendance"
                ? `Payment factor: ${
                    earningData?.holiday_attendance_payment_factor ?? "N/A"
                  }`
                : `Fixed Amount: ${
                    earningData?.holiday_attendance_fixed_amount ?? "N/A"
                  }`,
            indent: true,
          },
        ]
      : []),
  ];

  //absence paid

  const absenceFields = earningData?.is_absence_paid
    ? [
        {
          label: "Is Absence Paid",
          value: clearAbsenceValues
            ? "No"
            : earningData?.is_absence_paid
              ? "Yes"
              : "No",
        },
        !clearAbsenceValues && {
          label:
            earningData?.absent_payment_based_on === "Paid"
              ? "Absence is paid in full, no salary deduction"
              : "Absence is partly paid based on a payment factor",
          value:
            earningData?.absent_payment_based_on === "Paid"
              ? "Paid"
              : `Payment Factor: ${
                  earningData?.partial_payment_factor ?? "N/A"
                }`,
          indent: true,
        },
      ].filter(Boolean)
    : [
        {
          label: "Is Absence Paid",
          value: earningData?.is_absence_paid ? "Yes" : "No",
        },
      ];

  //penalty fields

  const penaltyFields =
    deductionsData?.is_apply_sft_penalty_policy && !sftPenaltyPolicy
      ? [
          {
            label: "Apply Shift Penalty Policy",
            value: deductionsData?.is_apply_sft_penalty_policy ? "Yes" : "No",
          },

          {
            label: "Penalty based on",
            value: deductionsData?.penalty_options,
            indent: true,
          },

          ...(deductionsData?.penalty_options === "hours"
            ? [
                {
                  label: "Deduction calculation based on",
                  value: deductionsData?.dedctions_options,
                  indent: true,
                },
              ]
            : []),
          {
            data: (
              <Box>
                {deductionsData?.penalty_options === "hours" &&
                deductionsData?.dedctions_options === "Attendance" ? (
                  <>
                    <Box mb={1}>
                      <Typography variant="body2" color="text.secondary">
                        For the first{" "}
                        <strong>
                          {deductionsData?.attendance_first_mins ?? "N/A"}
                        </strong>{" "}
                        mins of late arrival or early exit,a{" "}
                        <strong>
                          {deductionsData?.attendance_late_exit ?? "N/A"}
                        </strong>{" "}
                        mins deduction will be applied{" "}
                        <strong>
                          {deductionsData?.deductions_attendance_deduct_type ??
                            "N/A"}
                        </strong>
                      </Typography>
                    </Box>

                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        After that for every additional{" "}
                        <strong>
                          {deductionsData?.attendance_initial_mins ?? "N/A"}
                        </strong>{" "}
                        mins of early/late, a{" "}
                        <strong>
                          {deductionsData?.attendance_additional_mins ?? "N/A"}
                        </strong>{" "}
                        mins deduction will be applied
                      </Typography>
                    </Box>
                  </>
                ) : deductionsData?.penalty_options === "hours" &&
                  deductionsData?.dedctions_options === "Amount" ? (
                  <>
                    <Box mb={1}>
                      <Typography variant="body2" color="text.secondary">
                        If an employee is late arrival or early exit by{" "}
                        <strong>
                          {deductionsData?.fixed_amount_early_late ?? "N/A"}
                        </strong>{" "}
                        mins{" "}
                        <strong>
                          {deductionsData?.fixed_amount_deduct_amount ?? "N/A"}
                        </strong>{" "}
                        amount will be deducted{" "}
                        <strong>
                          {deductionsData?.deductions_fixed_amount_deduct_type ??
                            "N/A"}
                        </strong>
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        For every additional{" "}
                        <strong>
                          {deductionsData?.fixed_amount_extra_mins ?? "N/A"}
                        </strong>{" "}
                        mins an additional{" "}
                        <strong>
                          {deductionsData?.fixed_amount_early_late_deduct_amt ??
                            "N/A"}
                        </strong>{" "}
                        will be deductable{" "}
                        <strong>
                          {deductionsData?.deductions_fixed_amount_deduct_type ??
                            "N/A"}
                        </strong>
                      </Typography>
                    </Box>
                  </>
                ) : deductionsData?.penalty_options === "shift" ? (
                  <>
                    <Box mb={1}>
                      <Typography variant="body2" color="text.secondary">
                        If an employee is late arrival or early exit by{" "}
                        <strong>
                          {deductionsData?.sft_penalty_early_late_mins ?? "N/A"}
                        </strong>{" "}
                        mins{" "}
                        <strong>
                          {deductionsData?.sft_penalty_deduct ?? "N/A"}
                        </strong>{" "}
                        shift will be deducted
                      </Typography>
                    </Box>

                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        For every additional{" "}
                        <strong>
                          {deductionsData?.sft_penalty_additional_mins ?? "N/A"}
                        </strong>{" "}
                        mins, early or late, another{" "}
                        <strong>
                          {deductionsData?.sft_penalty_sft_deduct ?? "N/A"}
                        </strong>{" "}
                        shift will be deducted
                      </Typography>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box mb={1}>
                      <Typography variant="body2" color="text.secondary">
                        If an employee breaches the late entry/early exit
                        threshold{" "}
                        <strong>
                          {deductionsData?.sft_penalty_count_thershold ?? "N/A"}
                        </strong>{" "}
                        times,{" "}
                        <strong>
                          {deductionsData?.sft_penalty_count_deduct ?? "N/A"}
                        </strong>{" "}
                        shift will be deducted
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        For every additional breach of{" "}
                        <strong>
                          {deductionsData?.sft_penalty_count_additional_mins ??
                            "N/A"}
                        </strong>
                        the deduction will be{" "}
                        <strong>
                          {deductionsData?.sft_penalty_count_sft_deduct ??
                            "N/A"}
                        </strong>{" "}
                        shift
                      </Typography>
                    </Box>
                  </>
                )}
              </Box>
            ),
          },
        ]
      : [
          {
            label: "Apply Shift Penalty Policy",
            value: deductionsData?.is_apply_sft_penalty_policy ? "Yes" : "No",
          },
        ];

  // breakpenalty policy

  const breakPenaltyFields =
    deductionsData?.is_apply_break_penalty_policy && !sftPenaltyPolicy
      ? [
          {
            label: "Apply Break penalty policy",
            value: deductionsData?.is_apply_break_penalty_policy ? "Yes" : "No",
          },

          {
            label: "Break",
            value: deductionsData?.is_deduct_break_penalty_policy,
            indent: true,
          },

          {
            data: (
              <Box>
                <Box mb={1}>
                  <Typography variant="body2" color="text.secondary">
                    An extra break of up to{" "}
                    <strong>
                      {deductionsData?.extra_break_minutes ?? "N/A"}
                    </strong>{" "}
                    minutes will result in a{" "}
                    <strong>{deductionsData?.break_deduction ?? "N/A"}</strong>{" "}
                    minute deduction{" "}
                    <strong>
                      {deductionsData?.break_penalty_deduct_type ?? "N/A"}
                    </strong>
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    For every additional{" "}
                    <strong>
                      {deductionsData?.additional_break_minutes ?? "N/A"}
                    </strong>{" "}
                    minutes beyond that, another{" "}
                    <strong>
                      {deductionsData?.additional_break_deduction ?? "N/A"}
                    </strong>{" "}
                    minute deduction will be applied{" "}
                    <strong>
                      {deductionsData?.break_penalty_deduct_type ?? "N/A"}
                    </strong>
                  </Typography>
                </Box>
              </Box>
            ),
          },
        ]
      : [
          {
            label: "Apply Break penalty policy",
            value: deductionsData?.is_apply_break_penalty_policy ? "Yes" : "No",
          },
        ];

  //deduct salary

  const deductSalaryFields = deductionsData?.deduct_salary_for_absence
    ? [
        {
          label: "Deduct salary for absence",
          value: deductionsData?.deduct_salary_for_absence ? "Yes" : "No",
        },

        {
          data: (
            <Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  If an employee is absent for{" "}
                  <strong>{deductionsData?.deduction ?? "N/A"}</strong> day,
                  deduct an additional{" "}
                  <strong>
                    {deductionsData?.additional_deduction ?? "N/A"}
                  </strong>{" "}
                  day as penalty.
                </Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  For every extra{" "}
                  <strong>{deductionsData?.extra_deduction ?? "N/A"}</strong>{" "}
                  day of absence, deduct{" "}
                  <strong>
                    {deductionsData?.extra_additional_deduction ?? "N/A"}
                  </strong>{" "}
                  day as penalty.
                </Typography>
              </Box>
            </Box>
          ),
        },
      ]
    : [
        {
          label: "Deduct salary for absence",
          value: deductionsData?.deduct_salary_for_absence ? "Yes" : "No",
        },
      ];

  const onSubmit = (data) => {
    setFormValues(data);
    if (isEditScreen) {
      setOpenDialogConfimation(true);
    } else {
      updateShiftCategory(data);
    }
  };

  const updateShiftCategory = async (data) => {
    setValue("button_loader", true);
    const payload = {
      name: basicInfoData?.sft_category_name.trim(),
      ot_allowed: earningData?.is_overtime_allowed,
      shift_penalty_deduction: deductionsData?.is_apply_sft_penalty_policy,
      break_penalty_deduction: deductionsData?.is_apply_break_penalty_policy,
      is_paid_week_off: earningData?.is_weekoff_paid,
      is_paid_holiday: earningData?.is_holiday_paid,
      payment_based_on: basicInfoData?.payment_based_on,
      other_shift_grade_shifts_choice: basicInfoData?.is_include_sft_grade_sfts,
      payment_allowed_partial_shift_work: basicInfoData?.is_partial_shift_work,
      is_absence_paid: clearAbsenceValues
        ? false
        : earningData?.is_absence_paid,
      deduct_salary_for_absence: deductionsData?.deduct_salary_for_absence,
      weekoff_category: {
        payment_for_week_off_attendance:
          earningData?.is_payment_for_weekoff_day_attendance,

        ...(earningData?.is_payment_for_weekoff_day_attendance && {
          payment_based_on: earningData?.is_weekoff_payment_based_on,
          ...(earningData?.is_weekoff_payment_based_on === "Amount"
            ? { fixed_amount: earningData?.weekoff_attendance_fixed_amount }
            : {
                week_off_payment_factor:
                  earningData?.weekoff_attendance_payment_factor,
              }),
        }),
      },

      holiday_category: {
        payment_for_holiday_attendance:
          earningData?.is_payment_for_holiday_day_attendance,
        ...(earningData?.is_payment_for_holiday_day_attendance && {
          payment_based_on: earningData?.is_holiday_payment_based_on,
          ...(earningData?.is_holiday_payment_based_on === "Amount"
            ? { fixed_amount: earningData?.holiday_attendance_fixed_amount }
            : {
                holiday_payment_factor:
                  earningData?.holiday_attendance_payment_factor,
              }),
        }),
      },

      ...(basicInfoData?.payment_based_on === "Partial Shift Credit" && {
        compensation_rules: [
          {
            additional_percentage: basicInfoData?.additional_percentage,
            shift_per_day: basicInfoData?.shift_count,
            shift_percentage_ranges: basicInfoData?.rows?.map((row) => ({
              work_min_percentage: parseFloat(row.work_min_percentage),
              count_as_shift: parseFloat(row.count_as_shift),
            })),
          },
        ],
      }),

      ...(earningData?.is_overtime_allowed && {
        overtime_policies: [
          {
            ot_work_pre_authorization: earningData?.ot_work_preauthorization,
            ...(earningData?.calculation_based_on === "Hours" && {
              payment_based_on: earningData?.is_ot_payment_based_on,
            }),
            ...(earningData?.ot_work_preauthorization === "Automatic" && {
              ot_time_privilage: earningData?.ot_timing_privilege,
            }),
            calculation_based_on: earningData?.calculation_based_on,
            payment_factor:
              earningData?.calculation_based_on === "Hours" &&
              earningData?.is_ot_payment_based_on === "Attendance"
                ? 1
                : earningData?.ot_sft_payment_factor,
            added_payroll_default: earningData?.is_ot_pay_by_default,
            ...(earningData?.calculation_based_on === "Hours" &&
              earningData?.is_ot_payment_based_on === "Attendance" && {
                minimum_ot_consideration_minutes:
                  earningData?.minimum_ot_consideration,
                minutes_for_consideration:
                  earningData?.minutes_for_consideration,
                additional_ot_consideration_minutes: earningData?.additional_ot,
                additional_minutes_for_consideration:
                  earningData?.additional_minutes_for_consideration,
                consideration: earningData?.attendance_deduct_type,
              }),
            ...(earningData?.is_ot_payment_based_on === "Amount" && {
              consideration: earningData?.fixed_amount_deduct_type,
              threshold_ot_consideration_minutes:
                earningData?.ot_fixed_amount_thereshold_limit,
              ot_amount_payable: earningData?.ot_fixed_amount_payable,
              additional_threshold_ot_consideration_minutes:
                earningData?.ot_fixed_amount_additional_mins,
              additional_ot_amount_payable:
                earningData?.ot_fixed_amount_additional_payable,
            }),

            ...(earningData?.calculation_based_on === "Shift" && {
              overtime_compensation_rules: [
                {
                  additional_percentage:
                    earningData?.deduct_additional_percentage,
                  shift_per_day: earningData?.deduct_shift_count,
                  ot_percentage_ranges: earningData?.rows.map((row) => ({
                    work_min_percentage: parseFloat(row.work_min_percentage),
                    count_as_shift: parseFloat(row.count_as_shift),
                  })),
                },
              ],
            }),
          },
        ],
      }),

      ...(deductionsData?.is_apply_break_penalty_policy && {
        break_penalty_policies: [
          {
            extra_break_minutes: deductionsData?.extra_break_minutes,
            break_deduction: deductionsData?.break_deduction,
            additional_break_minutes: deductionsData?.additional_break_minutes,
            additional_break_deduction:
              deductionsData?.additional_break_deduction,
            apply_always:
              deductionsData?.is_deduct_break_penalty_policy === "always",
            deficit_working_hours:
              deductionsData?.is_deduct_break_penalty_policy === "deficit",
            consideration: deductionsData?.break_penalty_deduct_type,
          },
        ],
      }),

      ...(deductionsData?.is_apply_sft_penalty_policy && {
        deduction_policies: [
          {
            penalty_based_on: deductionsData?.penalty_options,
            deduction_based_on: deductionsData?.dedctions_options,
            ...(deductionsData?.dedctions_options === "Attendance" &&
              deductionsData?.penalty_options === "hours" && {
                payment_factor: 1,
              }),

            ...(deductionsData?.dedctions_options === "Attendance" &&
              deductionsData?.penalty_options === "hours" && {
                attendance_deductions: [
                  {
                    first_initial: deductionsData?.attendance_first_mins,
                    early_late: deductionsData?.attendance_late_exit,
                    deduction_type:
                      deductionsData?.deductions_attendance_deduct_type,
                    after_initial: deductionsData?.attendance_initial_mins,
                    additional_early_late:
                      deductionsData?.attendance_additional_mins,
                  },
                ],
              }),

            ...(deductionsData?.dedctions_options === "Amount" &&
              deductionsData?.penalty_options === "hours" && {
                fixed_amount_deductions: [
                  {
                    fixed_amount_early_late:
                      deductionsData?.fixed_amount_early_late,
                    fixed_amount_deduction:
                      deductionsData?.fixed_amount_deduct_amount,
                    deduction_type:
                      deductionsData?.deductions_fixed_amount_deduct_type,
                    fixed_amount_after_initial:
                      deductionsData?.fixed_amount_extra_mins,
                    fixed_amount_additional_deduction:
                      deductionsData?.fixed_amount_early_late_deduct_amt,
                  },
                ],
              }),
            ...(deductionsData?.penalty_options === "shift" && {
              shift_based_deductions: [
                {
                  shift_early_late: deductionsData?.sft_penalty_early_late_mins,
                  shift_deduction: deductionsData?.sft_penalty_deduct,
                  shift_after_initial:
                    deductionsData?.sft_penalty_additional_mins,
                  shift_additional_deduction:
                    deductionsData?.sft_penalty_sft_deduct,
                },
              ],
            }),

            ...(deductionsData?.penalty_options === "count" && {
              count_based_deductions: [
                {
                  count_early_late: deductionsData?.sft_penalty_count_thershold,
                  count_deduction: deductionsData?.sft_penalty_count_deduct,
                  count_after_initial:
                    deductionsData?.sft_penalty_count_additional_mins,
                  count_additional_deduction:
                    deductionsData?.sft_penalty_count_sft_deduct,
                },
              ],
            }),
          },
        ],
      }),

      ...(earningData?.is_absence_paid &&
        !clearAbsenceValues && {
          absent_earnings: {
            absent_payment_based_on: earningData?.absent_payment_based_on,
            ...(earningData?.absent_payment_based_on === "Partially Paid" && {
              partial_payment_factor: earningData?.partial_payment_factor,
            }),
          },
        }),

      ...(deductionsData?.deduct_salary_for_absence && {
        absent_deductions: {
          deduction: deductionsData?.deduction,
          additional_deduction: deductionsData?.additional_deduction,
          extra_deduction: deductionsData?.extra_deduction,
          extra_additional_deduction:
            deductionsData?.extra_additional_deduction,
        },
      }),
    };
    const url = isEditScreen
      ? `${domain}administration/shiftroster/shiftrota/shift-categories/${basicInfoData?.sftCategoryId}/`
      : `${domain}administration/shiftroster/shiftrota/shift-categories`;
    const method = isEditScreen ? "PUT" : "POST";
    try {
      const response = await customAPI(url, method, payload);

      if (response.ok) {
        const result = await response.responseDetails;

        showToast(
          "success",
          !isCreateScreen && !isEditScreen
            ? "Shift category cloned successfully"
            : "Update initiated successfully",
        );

        if (isEditScreen) {
          // Close edit screen
          closeEditScreen && closeEditScreen();
          // Close view panel
          setIsViewPanelOpen && setIsViewPanelOpen(false);
        } else {
          onClose && onClose();
        }

        // Call onTaskResponse if provided (for WebSocket etc.)
        if (onTaskResponse) {
          onTaskResponse(result);
        } else {
          // Just refresh data
          reCallApi(true);
        }

        setOpenDialogConfimation(false);
        setButtonLoader(false);
        setValue("button_loader", false);

        // Set handle loader for main component
        setHandleLoader && setHandleLoader(true);
      } else {
        setButtonLoader(false);
        setValue("button_loader", false);
      }
    } catch (error) {
      console.error("Update error:", error);
      setButtonLoader(false);
      setValue("button_loader", false);
    }
  };

  const handleDeactivateDialogBox = () => {
    setOpenDialogConfimation(false);
    setButtonLoader(false);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            overflow: "auto",
            p: 2,
          }}
          component="form"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2.5,
            }}
          >
            {!isPreview && <Divider sx={{ my: 3 }} />}
            <Typography
              fontWeight="bold"
              color="black"
              fontSize={16}
              textAlign="center"
            >
              {basicInfoData?.sft_category_name}
            </Typography>

            <Card variant="outlined" sx={{ borderColor: "#00000040" }}>
              <CardContent sx={{ p: 3 }}>
                {mainFields.map((field, index) => (
                  <React.Fragment key={field.label}>
                    <Box display="flex" justifyContent="space-between" py={1.5}>
                      <Typography fontSize={15} fontWeight={500}>
                        {field.label}
                      </Typography>
                      <Typography fontSize={15} color="#667084">
                        {field.value}
                      </Typography>
                    </Box>
                    {field.subFields && field.subFields.length > 0 && (
                      <Box mt={3}>
                        {field.subFields.map((sub, i) => (
                          <Box
                            key={i}
                            display="flex"
                            alignItems="flex-start"
                            pl={3}
                            gap={1}
                            mb={2}
                          >
                            <Box
                              sx={{
                                width: 6,
                                height: 6,
                                bgcolor: "#09bd71",
                                borderRadius: "2px",
                                mt: 0.5,
                              }}
                            />
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              flex={1}
                            >
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {sub.label}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {sub.value}
                              </Typography>
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    )}
                    {field?.table && <CustomTable data={field?.tableData} />}
                    <Box
                      mt={1}
                      ml={3}
                      mb={2}
                      display="flex"
                      alignItems="flex-start"
                    >
                      <Typography>{field.data}</Typography>
                    </Box>

                    {index < mainFields.length - 1 && (
                      <Divider sx={{ mt: 2 }} />
                    )}
                  </React.Fragment>
                ))}

                <Divider sx={{ my: 3 }} />

                {/* Weekoff Fields */}
                {weekoffFields.map((field) => (
                  <Box
                    sx={{
                      ...boxStyleSx,
                      pl: field.indent ? 3 : 0,
                    }}
                  >
                    {field.indent ? (
                      <Box
                        display="flex"
                        alignItems="flex-start"
                        flex={1}
                        gap={1}
                      >
                        <Box
                          sx={{
                            width: 6,
                            height: 6,
                            bgcolor: "#09bd71",
                            borderRadius: "2px",
                            mt: 0.5,
                          }}
                        />
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          flex={1}
                        >
                          <Typography variant="body2" color="text.secondary">
                            {field.label}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {field.value}
                          </Typography>
                        </Box>
                      </Box>
                    ) : (
                      <>
                        <Typography fontSize={15} fontWeight={600}>
                          {field.label}
                        </Typography>
                        <Typography fontSize={15} color="#667084">
                          {field.value}
                        </Typography>
                      </>
                    )}
                  </Box>
                ))}

                <Divider sx={{ my: 3 }} />

                {/* Holiday Fields */}
                {holidayFields.map((field) => (
                  <Box
                    sx={{
                      ...boxStyleSx,
                      pl: field.indent ? 3 : 0,
                    }}
                  >
                    {field.indent ? (
                      <Box
                        display="flex"
                        alignItems="flex-start"
                        flex={1}
                        gap={1}
                      >
                        <Box
                          sx={{
                            width: 6,
                            height: 6,
                            bgcolor: "#09bd71",
                            borderRadius: "2px",
                            mt: 0.5,
                          }}
                        />
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          flex={1}
                        >
                          <Typography variant="body2" color="text.secondary">
                            {field.label}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {field.value}
                          </Typography>
                        </Box>
                      </Box>
                    ) : (
                      <>
                        <Typography fontSize={15} fontWeight={600}>
                          {field.label}
                        </Typography>
                        <Typography fontSize={15} color="#667084">
                          {field.value}
                        </Typography>
                      </>
                    )}
                  </Box>
                ))}
                <Divider sx={{ my: 3 }} />

                {absenceFields.map((field) => (
                  <Box
                    sx={{
                      ...boxStyleSx,
                      pl: field.indent ? 3 : 0,
                    }}
                  >
                    {field.indent ? (
                      <Box
                        display="flex"
                        alignItems="flex-start"
                        flex={1}
                        gap={1}
                      >
                        <Box
                          sx={{
                            width: 6,
                            height: 6,
                            bgcolor: "#09bd71",
                            borderRadius: "2px",
                            mt: 0.5,
                          }}
                        />
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          flex={1}
                        >
                          <Typography variant="body2" color="text.secondary">
                            {field.label}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {field.value}
                          </Typography>
                        </Box>
                      </Box>
                    ) : (
                      <>
                        <Typography fontSize={15} fontWeight={600}>
                          {field.label}
                        </Typography>
                        <Typography fontSize={15} color="#667084">
                          {field.value}
                        </Typography>
                      </>
                    )}
                  </Box>
                ))}

                <Divider sx={{ my: 3 }} />

                {/* Penalty Fields */}
                {basicInfoData?.payment_based_on !== "Hours" && (
                  <>
                    {penaltyFields.map((field) => (
                      <>
                        <Box
                          sx={{
                            ...boxStyleSx,
                            pl: field.indent ? 3 : 0,
                          }}
                        >
                          {field.indent ? (
                            <Box
                              display="flex"
                              alignItems="flex-start"
                              flex={1}
                              gap={1}
                            >
                              <Box
                                sx={{
                                  width: 6,
                                  height: 6,
                                  bgcolor: "#09bd71",
                                  borderRadius: "2px",
                                  mt: 0.5,
                                }}
                              />
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                flex={1}
                              >
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {field.label}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {field.value}
                                </Typography>
                              </Box>
                            </Box>
                          ) : (
                            <>
                              <Typography fontSize={15} fontWeight={600}>
                                {field.label}
                              </Typography>
                              <Typography fontSize={15} color="#667084">
                                {field.value}
                              </Typography>
                            </>
                          )}
                        </Box>
                        <Box ml={3} display="flex" alignItems="flex-start">
                          <Typography>{field.data}</Typography>
                        </Box>
                      </>
                    ))}
                  </>
                )}

                <Divider sx={{ my: 3 }} />

                {/* Break Penalty Fields */}
                {breakPenaltyFields.map((field) => (
                  <>
                    <Box
                      sx={{
                        ...boxStyleSx,
                        pl: field.indent ? 3 : 0,
                      }}
                    >
                      {field.indent ? (
                        <Box
                          display="flex"
                          alignItems="flex-start"
                          flex={1}
                          gap={1}
                        >
                          <Box
                            sx={{
                              width: 6,
                              height: 6,
                              bgcolor: "#09bd71",
                              borderRadius: "2px",
                              mt: 0.5,
                            }}
                          />
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            flex={1}
                          >
                            <Typography variant="body2" color="text.secondary">
                              {field.label}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {field.value}
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        <>
                          <Typography fontSize={15} fontWeight={600}>
                            {field.label}
                          </Typography>
                          <Typography fontSize={15} color="#667084">
                            {field.value}
                          </Typography>
                        </>
                      )}
                    </Box>
                    <Box ml={3} display="flex" alignItems="flex-start">
                      <Typography>{field.data}</Typography>
                    </Box>
                  </>
                ))}
                <Divider sx={{ my: 3 }} />

                {deductSalaryFields.map((field) => (
                  <>
                    <Box
                      sx={{
                        ...boxStyleSx,
                        pl: field.indent ? 3 : 0,
                      }}
                    >
                      {field.indent ? (
                        <Box
                          display="flex"
                          alignItems="flex-start"
                          flex={1}
                          gap={1}
                        >
                          <Box
                            sx={{
                              width: 6,
                              height: 6,
                              bgcolor: "#09bd71",
                              borderRadius: "2px",
                              mt: 0.5,
                            }}
                          />
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            flex={1}
                          >
                            <Typography variant="body2" color="text.secondary">
                              {field.label}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {field.value}
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        <>
                          <Typography fontSize={15} fontWeight={600}>
                            {field.label}
                          </Typography>
                          <Typography fontSize={15} color="#667084">
                            {field.value}
                          </Typography>
                        </>
                      )}
                    </Box>
                    <Box ml={3} display="flex" alignItems="flex-start">
                      <Typography>{field.data}</Typography>
                    </Box>
                  </>
                ))}
              </CardContent>
            </Card>

            {/* Create Button */}
            {!isPreview && (
              <Box
                sx={{
                  ml: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <CustomButton
                    actionName="Prev"
                    typeName="button"
                    actionFuntion={() => {
                      handleBack(2);
                    }}
                  />
                </Box>
                <Box>
                  <CustomButton
                    actionName={
                      isCreateScreen
                        ? "Create"
                        : isEditScreen
                          ? "Update"
                          : "Clone"
                    }
                    typeName="submit"
                    disableAction={watch("button_loader")}
                  />
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      <Mui.Dialog
        open={openDialogConfimation}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          handleDeactivateDialogBox();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: 650,
            maxWidth: "100%",
            borderRadius: 2,
          },
        }}
      >
        <Mui.DialogTitle id="alert-dialog-title">
          Update Shift Category
          <IconButton
            aria-label="close"
            onClick={handleDeactivateDialogBox}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </Mui.DialogTitle>
        <Mui.Divider />

        <Mui.DialogContent>
          <Mui.DialogContentText id="alert-dialog-description">
            Updating this shift category will affect historical records,
            including attendance, overtime, and penalties. Do you want to
            proceed with these changes?
          </Mui.DialogContentText>
        </Mui.DialogContent>

        <Mui.DialogActions sx={{ mr: 2, mb: 1 }}>
          <CustomButtonWithBorder
            actionName={"Cancel"}
            actionFuntion={handleDeactivateDialogBox}
          />

          <CustomButtonWithBorder
            actionName={"Confirm"}
            actionFuntion={() => {
              updateShiftCategory(formValues);
            }}
            disableAction={openDialogConfimation && buttonLoader ? true : false}
            handleColor={true}
          />
        </Mui.DialogActions>
      </Mui.Dialog>
    </>
  );
};
